import { TenantList } from '../util/tenant.mapper';

// ts-unused-exports:disable-next-line
export const useFormatTenantID = (tenantId: string): string | undefined => {
  try {
    const customerCode = getTenantCustomerCode(tenantId);

    const splitValues = tenantId.match(/^(.*?)(dev|test|prod)?$/);
    return splitValues ? `${customerCode}-${splitValues[2]}` : undefined;
  } catch (e) {
    return undefined;
  }
};

//map tenantId to customerCode
const getTenantCustomerCode = (tenantId: string): string | undefined => {
  const tenant = TenantList.find((t) => t.tenantCodes.includes(tenantId));
  if (tenant) {
    return tenant.customerCode;
  }
  return undefined;
};
